/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Team_Lead8Inputs */

const cs_role_team_lead8 = /** @type {(inputs: Role_Team_Lead8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedoucí týmu`)
};

const en_role_team_lead8 = /** @type {(inputs: Role_Team_Lead8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team lead`)
};

/**
* | output |
* | --- |
* | "Team lead" |
*
* @param {Role_Team_Lead8Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_team_lead8 = /** @type {((inputs?: Role_Team_Lead8Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Team_Lead8Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_team_lead8(inputs)
	return cs_role_team_lead8(inputs)
});
export { role_team_lead8 as "role_TEAM_LEAD" }